const localeEn = {
  UDE_ACADEMIES_ERROR: 'An error occurred while fetching your academies',
};
export default localeEn;
